(function () {
  'use strict';
  if (window.TJSHomeStartup) return;
  let active = null, bootObserver = null;
  const homeHash = () => !location.hash.startsWith('#/') || location.hash.split('?')[0] === '#/';
  function dispose() { if (active) { active.dispose(); active = null; } }
  function mount(hero) {
    if (!hero) { dispose(); return; }
    if (active?.hero === hero) return;
    dispose();
    const video = hero.querySelector('video');
    if (!video) return;
    const source = video.querySelector('source');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const listeners = [];
    const rect = hero.getBoundingClientRect();
    let visible = rect.bottom > 0 && rect.top < innerHeight;
    let disposed = false, pending = false, failed = false, hasFrame = false;
    let observer, frame = null, deadline;
    function listen(target, type, callback, options) {
      target?.addEventListener(type, callback, options);
      listeners.push(() => target?.removeEventListener(type, callback, options));
    }
    function settle() {
      clearTimeout(deadline);
      hero.classList.remove('is-media-pending');
      hero.classList.add('is-startup-settled');
    }
    function cancelFrame() {
      if (frame !== null) { video.cancelVideoFrameCallback?.(frame); frame = null; }
    }
    function fallback() {
      if (disposed) return;
      cancelFrame();hasFrame = false;video.pause();video.hidden = true;
      hero.classList.remove('is-video-ready');hero.classList.add('is-video-fallback');settle();
    }
    const shouldPlay = () => !disposed && !failed && !reduced.matches && !document.hidden && visible;
    function revealFrame() {
      if (hasFrame || frame !== null || !shouldPlay() || video.paused) return;
      const reveal = () => {
        frame = null;
        if (!shouldPlay() || video.paused || video.hidden) return;
        hasFrame = true;hero.classList.remove('is-video-fallback');
        hero.classList.add('is-video-ready');settle();
      };
      if (typeof video.requestVideoFrameCallback === 'function') frame = video.requestVideoFrameCallback(reveal);
      else if (video.readyState >= 2) reveal();
    }
    function configure() {
      if (disposed || failed) return;
      if (reduced.matches) { fallback();return; }
      if (!shouldPlay()) { video.pause();cancelFrame();return; }
      video.hidden = false;
      if (source?.dataset.src && !source.getAttribute('src')) {
        source.src = source.dataset.src;video.preload = 'auto';video.load();
      }
      if (pending) return;
      if (!video.paused) { revealFrame();return; }
      pending = true;
      try {
        Promise.resolve(video.play()).then(() => {
          pending = false;
          if (shouldPlay()) revealFrame();else video.pause();
        }).catch(() => { pending = false;if (!disposed) fallback(); });
      } catch (_) { pending = false;fallback(); }
    }
    video.muted = true;video.defaultMuted = true;video.loop = true;video.playsInline = true;
    hero.classList.add('is-media-pending');
    deadline = setTimeout(settle, 1800);
    listen(video, 'playing', revealFrame);
    listen(video, 'loadeddata', revealFrame);
    const mediaFailed = () => { failed = true;fallback(); };
    listen(video, 'error', mediaFailed);listen(source, 'error', mediaFailed);
    listen(video, 'ended', () => { if (shouldPlay()) { video.currentTime = 0;configure(); } });
    listen(reduced, 'change', configure);
    listen(document, 'visibilitychange', configure);
    listen(document, 'pointerdown', () => { if (video.hidden && !reduced.matches) configure(); }, {passive:true});
    listen(window, 'pagehide', () => { video.pause();cancelFrame();settle(); });
    listen(window, 'pageshow', configure);
    if (typeof IntersectionObserver !== 'undefined') {
      observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting;configure(); }, {threshold:0});
      observer.observe(hero);
    }
    active = {hero, dispose() {
      disposed = true;cancelFrame();clearTimeout(deadline);video.pause();
      observer?.disconnect();listeners.forEach(remove => remove());settle();
    }};
    configure();
  }
  function render(main, html, isHome) {
    if (!main) return;
    bootObserver?.disconnect();
    document.documentElement.removeAttribute('data-tjs-initial-home');
    const existing = main.querySelector(':scope > [data-tjs-home-hero]');
    if (isHome && existing) main.querySelector(':scope > [data-tjs-native-home-sections]')?.remove();
    if (!isHome || !existing) {
      dispose();main.innerHTML = html;
    } else if (!main.querySelector(':scope > .home-experience')) {
      const template = document.createElement('template');template.innerHTML = html;
      template.content.querySelector('[data-tjs-home-hero]')?.remove();
      main.append(template.content);
    }
    mount(isHome ? main.querySelector(':scope > [data-tjs-home-hero]') : null);
  }
  window.TJSHomeStartup = {mount, render, dispose};
  function boot() {
    const hero = document.querySelector('#main > [data-tjs-home-hero]');
    if (!hero || !hero.querySelector('.hero-copy')) return false;
    if (!homeHash()) hero.remove();else mount(hero);
    bootObserver?.disconnect();return true;
  }
  if (!boot() && document.readyState !== 'complete') {
    bootObserver = new MutationObserver(boot);
    bootObserver.observe(document.documentElement, {childList:true,subtree:true});
    document.addEventListener('DOMContentLoaded', () => { boot();bootObserver?.disconnect(); }, {once:true});
  }
}());
